import moment from 'moment';
import { http } from 'services';

export const fetchStatByDocument = async ({ params: { date, ..._params } }: { params: Record<string, any> }) => {
  let year = '';
  let month = '';

  if (date) {
    year = moment(date).format('YYYY');
    month = moment(date).format('MM');
  }

  return http.request.get('/register/stat/by-document-type', {
    params: {
      year: year || undefined,
      month: month || undefined,
      ..._params
    }
  });
};

export const fetchStatByDocumentTypes = async ({ params: { date, ..._params } }: { params: Record<string, any> }) => {
  let year = '';
  let month = '';

  if (date) {
    year = moment(date).format('YYYY');
    month = moment(date).format('MM');
  }
  return http.request.get('/application/open_source/stat/document-type', {
    params: {
      year: year || undefined,
      month: month || undefined,
      ..._params
    }
  });
};
